import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';
import LogoutButton from './LogoutButton';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const Header = () => {
    const { user } = useAuth0();
  
    return (
      <Navbar bg="light" variant="light" expand="lg" className="py-3">
        <Container>
          <Link to="/" className="text-decoration-none">
            <Navbar.Brand className="app-title">
              <span style={{ color: 'var(--primary-color)' }}>JIT</span>
              <span style={{ color: 'var(--secondary-color)' }}> IAM</span>
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto d-flex align-items-center">
              <Nav.Item className="me-3">
                <span className="badge bg-light text-secondary border">
                  <i className="bi bi-person-circle me-1"></i>
                  {user.nickname}
                </span>
              </Nav.Item>
              <LogoutButton />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
}
  
export default Header